import { FC, useRef, useLayoutEffect } from 'react'
import * as styles from 'components/features/pfm/TextareaSafariProbe/TextareaSafariProbe.styl'

const PROBE_TEXT = 'iiiiiiiiiiiiiiiiiiiiiiiii'

type TextareaSafariProbeProps = {
  onResult: (isCorrect: boolean | null) => void
}

export const TextareaSafariProbe: FC<TextareaSafariProbeProps> = (props) => {
  const { onResult } = props

  const taRef = useRef<HTMLTextAreaElement>(null)
  const refRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const taNode = taRef.current
    const refNode = refRef.current
    if (!taNode || !refNode) {
      return
    }

    const computedStyles = window.getComputedStyle(refNode)
    const borderStyle = computedStyles.getPropertyValue('border-style')
    const isStylesLoaded = borderStyle === 'dashed'
    if (!isStylesLoaded) {
      onResult(null)
    }

    const rect = refNode.getBoundingClientRect()
    taNode.style.width = `${ rect.width }px`
    taNode.style.height = `${ rect.height }px`

    // ios safari applies 2 extra pixels to scrollHeight, thats why we have to check the difference
    const isCorrect = Math.abs(taNode.scrollHeight - rect.height) < 3

    onResult(isCorrect)
  }, [onResult])

  return (
    <div className={ styles.textareaSafariProbe }>
      <textarea
        ref={ taRef }
        className={ styles.probe }
        value={ PROBE_TEXT }
        readOnly
      />
      <div
        ref={ refRef }
        className={ styles.probe }
      >
        { PROBE_TEXT }
      </div>
    </div>
  )
}
